import React from "react";
import { Location } from "@navigation";
import { Form } from "@modules/formx-react";
import { PriceGroupForm } from "./PriceGroupForm";
import { CustomerContractPriceListFormStore } from "../CustomerContractPriceListFormStore";
import { CustomerContractPriceListFormContext } from "../CustomerContractPriceListFormContext";

type Params = {
  contractId: string;
  priceListId: string;
  priceGroupId: string;
};

export class PriceGroupFormLocation extends Location<Params> {
  constructor(
    contractId: string,
    priceListId: string,
    priceGroupId: string,
    public store: CustomerContractPriceListFormStore
  ) {
    super({ contractId, priceListId, priceGroupId });
  }

  render() {
    return (
      <CustomerContractPriceListFormContext.Provider value={this.store}>
        <Form store={this.store.form}>
          <PriceGroupForm priceGroupId={this.params.priceGroupId} />
        </Form>
      </CustomerContractPriceListFormContext.Provider>
    );
  }

  toURI(): string {
    return `/customer_contracts/${this.params.contractId}/price_lists/${this.params.priceListId}/price_group/${this.params.priceGroupId}`;
  }
}
